import { render } from "./TransferCreate.vue?vue&type=template&id=02f647b8"
import script from "./TransferCreate.vue?vue&type=script&lang=js"
export * from "./TransferCreate.vue?vue&type=script&lang=js"

import exportComponent from "/Users/david/Desktop/projects/ConexionCreativa/real-gestion/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__